import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    currentPage:1,
    user: {
      loggedIn: false,
      data: null
    },
    keywordsAlerts: [],
    searchedWords: '',
    selectedInitialDate:'',
    selectedEndDate:'',
    dataList:[],
    focusClass:'',
    selectedMinistry: [],
    selectedActTypeModification:[],
    showTypeAdvancedSearch:false,
    selectedTypeAdvancedSearch:'',
    selectedAdvancedSearch:'',
    
    showSavedPrivacyPolicy:'',
    privacyPolicyPage:'',
    privacyPolicyOk:''
  },
  getters: {
    user(state){
      return state.user
    },
    keywordsAlerts(state){
      return state.keywordsAlerts
    },
    searchedWords(state){
      return state.searchedWords
    },
    selectedInitialDate(state){
      return state.selectedInitialDate
    },
    selectedEndDate(state){
      return state.selectedEndDate
    },

    dataList(state){
      return state.dataList
    },

    currentPage(state){
      return state.currentPage;
    },
    
    focusClass(state){
      return state.focusClass;
    },

    selectedMinistry(state){
      return state.selectedMinistry
    },

    selectedActTypeModification(state){
      return state.selectedActTypeModification
    },

    showTypeAdvancedSearch(state){
      return state.showTypeAdvancedSearch
    },

    selectedTypeAdvancedSearch(state){
      return state.selectedTypeAdvancedSearch
    },

    selectedAdvancedSearch(state){
      return state.selectedAdvancedSearch
    },

    showSavedPrivacyPolicy(state){
      return state.showSavedPrivacyPolicy
    },

    privacyPolicyPage(state){
      return state.privacyPolicyPage
    },

    privacyPolicyOk(state){
      return state.privacyPolicyOk
    },

    loggedIn: state => !!state.user.loggedIn

  },
  
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },

    SET_USER(state, data) {
      state.user.data = data;
    },

    addkeywordsAlerts(state,value){
      state.keywordsAlerts.push(value);
    },

    removeKeywordsAlerts(state,item){
      let index = state.keywordsAlerts.indexOf(item);
      if (index > -1) {
        state.keywordsAlerts.splice(index, 1);
      }
    },

    updateKeywordsAlerts(state, items){
      let index = state.keywordsAlerts.indexOf(items.currentItem);
      if (index > -1) {
        Object.assign(state.keywordsAlerts[index], items.itemUpdated);
      }
    },

    clearkeywordsAlerts(state){
      state.keywordsAlerts = []
    },

    setSearchedWords(state, value) {
      state.searchedWords = value;
    },

    setSelectedInitialDate(state, value) {
      state.selectedInitialDate = value;
    },

    setSelectedEndDate(state, value) {
      state.selectedEndDate = value;
    },


    setDataList(state, value){
      state.dataList = value;
    },

    setCurrentPage(state,value){
      state.currentPage = value;
    },

    setFocusClass(state,value){
      state.focusClass = value;
    },

    setSelectedActTypeModification(state, value) {
      state.selectedActTypeModification = value;
    },

    setSelectedMinistry(state, value) {
      state.selectedMinistry = value;
    },

    setShowTypeAdvancedSearch(state, value) {
      state.showTypeAdvancedSearch = value;
    },

    setSelectedTypeAdvancedSearch(state, value) {
      state.selectedTypeAdvancedSearch = value;
    },

    setSelectedAdvancedSearch(state, value) {
      state.selectedAdvancedSearch = value;
    },

    
    setShowSavedPrivacyPolicy(state,value){
      state.showSavedPrivacyPolicy =  value
    },

    setPrivacyPolicyPage(state,value){
      state.privacyPolicyPage =  value
    },

    setPrivacyPolicyOk(state,value){
      state.privacyPolicyOk =  value
    }
    
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
          id: user.uid
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});
